import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from "../state";
import {ActionContext} from "vuex";
import {AuthState, TokenData} from "./authState";

type AuthContext = ActionContext<AuthState, RootState>;

export const auth = {
    namespaced: true,

    state: {
        oauthToken: localStorage.getItem('jwt') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        isAuthenticated:false,
        hasLoadedOnce: false
    },

    getters: {
        isAuthenticated(state: AuthState) {
            return Boolean(state.oauthToken);
        },
        getAuthToken(state: AuthState){
            return state.oauthToken;
        },
        getRefreshToken(state: AuthState){
            return state.refreshToken;
        }
    },

    mutations: {
        setToken(state: AuthState, tokenData: TokenData) {
            state.oauthToken = tokenData.oauthToken
            state.refreshToken = tokenData.refreshToken
            state.isAuthenticated = true;
            state.hasLoadedOnce = true;
        },
        clearToken(state: AuthState) {
            state.oauthToken = ''
            state.isAuthenticated = false;
            state.hasLoadedOnce = false;
        }
    },

    actions: {
         setToken(context: AuthContext, tokenData: TokenData) {
             localStorage.setItem('jwt',tokenData.oauthToken);
             localStorage.setItem('refreshToken', tokenData.refreshToken)
             commitToken(context, tokenData)
        },
        clearToken(context: AuthContext, token: string) {
            commitClearToken(context)
        },
    },
};
const { commit, read, dispatch } =
    getStoreAccessors<AuthState, RootState>("auth");

const getters = auth.getters;
export const isAuthenticated = read(getters.isAuthenticated);
export const getAuthToken = read(getters.getAuthToken);
export const getRefreshToken = read(getters.getRefreshToken);
const actions = auth.actions;
export const setToken =dispatch(actions.setToken)
export const setClearToken =dispatch(actions.clearToken)

const mutations = auth.mutations;
export const commitToken = commit(mutations.setToken);
export const commitClearToken = commit(mutations.clearToken);
